import React, { useRef, useState } from "react";
import Style from "./AllTaxiReqTabel.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const AllTaxiReqTabel = ({ modalHandler, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شماره سفارش",
      dataIndex: "key",
      key: "key",
      ...getColumnSearchProps("key", "شماره سفارش"),
    },
    {
      title: "نام راننده",
      dataIndex: "driver",
      key: "driver",
      ...getColumnSearchProps("driver", "نام راننده"),
    },
    {
      title: "شماره راننده",
      dataIndex: "driverphone",
      key: "driverphone",
      ...getColumnSearchProps("driverphone", "شماره راننده"),
    },
    {
      title: "نام مسافر",
      dataIndex: "passengerName",
      key: "passengerName",
      ...getColumnSearchProps("passengerName", "نام مسافر"),
    },
    {
      title: "شماره مسافر",
      dataIndex: "passengerPhone",
      key: "passengerPhone",
      ...getColumnSearchProps("passengerPhone", "شماره مسافر"),
    },
    {
      title: "کرایه",
      dataIndex: "payment",
      key: "payment",
      ...getColumnSearchProps("payment", "کرایه"),
    },
    {
      title: "زمان درخواست",
      dataIndex: "taxi_Request",
      key: "taxi_Request",
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      ...getColumnSearchProps("status", "وضعیت"),
      render: (text) =>
        text === "0" ? (
          <p style={{ color: "orange" }}>منتظر تایید راننده</p>
        ) : text === "1" ? (
          <p style={{ color: "blue" }}>راننده در مسیر مبدأ</p>
        ) : text === "2" ? (
          <p style={{ color: "blue" }}>راننده در مبدأ است!</p>
        ) : text === "3" ? (
          <p style={{ color: "blue" }}>در مسیر مقصد!</p>
        ) : text === "4" ? (
          <p style={{ color: "green" }}>اتمام سفر</p>
        ) : text === "-2" ? (
          <p style={{ color: "red" }}> سفر لغو شده</p>
        ) : text === "-1" ? (
          <p style={{ color: "red" }}> توسط راننده کنسل شد! </p>
        ) : null,
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => modalHandler(record)}
            className={Style.deleteBtn}
          >
            اطلاعت سفر
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
      />
    </div>
  );
};

export default AllTaxiReqTabel;
